var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("h1", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.T.wordsContests))
        ])
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            {
              staticClass: "sidebar",
              attrs: {
                pills: "",
                card: "",
                vertical: "",
                "nav-wrapper-class":
                  "contest-list-nav col-md-2 col-sm-12 test-class"
              }
            },
            [
              _c(
                "b-card",
                { staticClass: "card-group-menu" },
                [
                  _c(
                    "b-container",
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "justify-content-between",
                          attrs: { "align-v": "center" }
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "col-12 col-md-5 mb-2 mb-md-0 p-0" },
                            [
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.onSearchQuery($event)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.lazy",
                                          value: _vm.currentQuery,
                                          expression: "currentQuery",
                                          modifiers: { lazy: true }
                                        }
                                      ],
                                      staticClass: "form-control nav-link",
                                      attrs: {
                                        type: "text",
                                        name: "query",
                                        autocomplete: "off",
                                        autocorrect: "off",
                                        autocapitalize: "off",
                                        spellcheck: "false",
                                        placeholder: _vm.T.wordsKeyword
                                      },
                                      domProps: { value: _vm.currentQuery },
                                      on: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.onSearchQuery($event)
                                        },
                                        change: function($event) {
                                          _vm.currentQuery = $event.target.value
                                        }
                                      }
                                    }),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn reset-btn nav-link",
                                        attrs: { type: "reset" },
                                        on: { click: _vm.onReset }
                                      },
                                      [_vm._v(" × ")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "input-group-append" },
                                      [
                                        _c("input", {
                                          staticClass:
                                            "btn btn-primary btn-style btn-md btn-block active nav-link",
                                          attrs: { type: "submit" },
                                          domProps: { value: _vm.T.wordsSearch }
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex col-md-6 btns-group p-0",
                              attrs: { sm: "12" }
                            },
                            [
                              _c(
                                "b-dropdown",
                                {
                                  ref: "dropdownOrderBy",
                                  attrs: {
                                    "no-caret": "",
                                    "data-dropdown-order": ""
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "button-content",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "sort-amount-down"
                                                }
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.T.contestOrderBy) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-order-by-ends": ""
                                      },
                                      on: { click: _vm.orderByEnds }
                                    },
                                    [
                                      _vm.currentOrder === _vm.ContestOrder.Ends
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(_vm._s(_vm.T.contestOrderByEnds))
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-order-by-title": ""
                                      },
                                      on: { click: _vm.orderByTitle }
                                    },
                                    [
                                      _vm.currentOrder ===
                                      _vm.ContestOrder.Title
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(_vm._s(_vm.T.contestOrderByTitle))
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-order-by-duration": ""
                                      },
                                      on: { click: _vm.orderByDuration }
                                    },
                                    [
                                      _vm.currentOrder ===
                                      _vm.ContestOrder.Duration
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(_vm.T.contestOrderByDuration)
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-order-by-organizer": ""
                                      },
                                      on: { click: _vm.orderByOrganizer }
                                    },
                                    [
                                      _vm.currentOrder ===
                                      _vm.ContestOrder.Organizer
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(_vm.T.contestOrderByOrganizer)
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-order-by-contestants": ""
                                      },
                                      on: { click: _vm.orderByContestants }
                                    },
                                    [
                                      _vm.currentOrder ===
                                      _vm.ContestOrder.Contestants
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(_vm.T.contestOrderByContestants)
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-order-by-signed-up": ""
                                      },
                                      on: { click: _vm.orderBySignedUp }
                                    },
                                    [
                                      _vm.currentOrder ===
                                      _vm.ContestOrder.SignedUp
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(_vm.T.contestOrderBySignedUp)
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-dropdown",
                                {
                                  ref: "dropdownFilterBy",
                                  staticClass: "mr-0",
                                  attrs: {
                                    "no-caret": "",
                                    "data-dropdown-filter": ""
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "button-content",
                                      fn: function() {
                                        return [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "filter" }
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.T.contestFilterBy) +
                                              " "
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-filter-by-all": ""
                                      },
                                      on: { click: _vm.filterByAll }
                                    },
                                    [
                                      _vm.currentFilter ===
                                      _vm.ContestFilter.All
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(_vm._s(_vm.T.contestFilterByAll))
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-filter-by-signed-up": ""
                                      },
                                      on: { click: _vm.filterBySignedUp }
                                    },
                                    [
                                      _vm.currentFilter ===
                                      _vm.ContestFilter.SignedUp
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(_vm.T.contestFilterBySignedUp)
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        href: "#",
                                        "data-filter-by-recommended": ""
                                      },
                                      on: { click: _vm.filterByRecommended }
                                    },
                                    [
                                      _vm.currentFilter ===
                                      _vm.ContestFilter.OnlyRecommended
                                        ? _c("font-awesome-icon", {
                                            staticClass: "mr-1",
                                            attrs: { icon: "check" }
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(_vm.T.contestFilterByRecommended)
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-tab",
                {
                  ref: "currentContestTab",
                  staticClass: "scroll-content",
                  attrs: {
                    title: _vm.T.contestListCurrent,
                    "title-link-class": _vm.titleLinkClass(
                      _vm.ContestTab.Current
                    ),
                    active: _vm.currentTab === _vm.ContestTab.Current
                  },
                  on: {
                    click: function($event) {
                      _vm.currentTab = _vm.ContestTab.Current
                    }
                  }
                },
                [
                  _vm.loading || _vm.refreshing
                    ? _vm._l(3, function(index) {
                        return _c(
                          "div",
                          {
                            key: "current-" + index,
                            staticClass: "card contest-card mb-3"
                          },
                          [_c("div", { staticClass: "line" })]
                        )
                      })
                    : _vm.contestListEmpty
                    ? _c("div", { staticClass: "empty-category" }, [
                        _vm._v(" " + _vm._s(_vm.T.contestListEmpty) + " ")
                      ])
                    : _vm._l(_vm.contestList, function(contestItem) {
                        return _c("omegaup-contest-card", {
                          key: contestItem.contest_id,
                          attrs: { contest: contestItem },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "contest-button-scoreboard",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "text-contest-date",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-card-text",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "calendar-alt" }
                                        }),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getTimeLink(
                                                contestItem.finish_time
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.ui.formatString(
                                                    _vm.T.contestEndTime,
                                                    {
                                                      endDate: _vm.finishContestDate(
                                                        contestItem
                                                      )
                                                    }
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "contest-dropdown",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                  _vm.loading && !_vm.contestListEmpty
                    ? _vm._l(3, function(index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card contest-card mb-3" },
                          [_c("div", { staticClass: "line" })]
                        )
                      })
                    : _vm._e()
                ],
                2
              ),
              _c(
                "b-tab",
                {
                  ref: "futureContestTab",
                  staticClass: "scroll-content",
                  attrs: {
                    title: _vm.T.contestListFuture,
                    "title-link-class": _vm.titleLinkClass(
                      _vm.ContestTab.Future
                    ),
                    active: _vm.currentTab === _vm.ContestTab.Future
                  },
                  on: {
                    click: function($event) {
                      _vm.currentTab = _vm.ContestTab.Future
                    }
                  }
                },
                [
                  _vm.loading || _vm.refreshing
                    ? _vm._l(3, function(index) {
                        return _c(
                          "div",
                          {
                            key: "current-" + index,
                            staticClass: "card contest-card mb-3"
                          },
                          [_c("div", { staticClass: "line" })]
                        )
                      })
                    : _vm.contestListEmpty
                    ? _c("div", { staticClass: "empty-category" }, [
                        _vm._v(" " + _vm._s(_vm.T.contestListEmpty) + " ")
                      ])
                    : _vm._l(_vm.contestList, function(contestItem) {
                        return _c("omegaup-contest-card", {
                          key: contestItem.contest_id,
                          attrs: { contest: contestItem },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "contest-button-scoreboard",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "text-contest-date",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-card-text",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "calendar-alt" }
                                        }),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getTimeLink(
                                                contestItem.start_time
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.ui.formatString(
                                                    _vm.T.contestStartTime,
                                                    {
                                                      startDate: _vm.startContestDate(
                                                        contestItem
                                                      )
                                                    }
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "contest-button-enter",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "contest-dropdown",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                  _vm.loading && !_vm.contestListEmpty
                    ? _vm._l(3, function(index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card contest-card mb-3" },
                          [_c("div", { staticClass: "line" })]
                        )
                      })
                    : _vm._e()
                ],
                2
              ),
              _c(
                "b-tab",
                {
                  ref: "pastContestTab",
                  staticClass: "scroll-content",
                  attrs: {
                    title: _vm.T.contestListPast,
                    "title-link-class": _vm.titleLinkClass(_vm.ContestTab.Past),
                    active: _vm.currentTab === _vm.ContestTab.Past
                  },
                  on: {
                    click: function($event) {
                      _vm.currentTab = _vm.ContestTab.Past
                    }
                  }
                },
                [
                  _vm.loading || _vm.refreshing
                    ? _vm._l(3, function(index) {
                        return _c(
                          "div",
                          {
                            key: "current-" + index,
                            staticClass: "card contest-card mb-3"
                          },
                          [_c("div", { staticClass: "line" })]
                        )
                      })
                    : _vm.contestListEmpty
                    ? _c("div", { staticClass: "empty-category" }, [
                        _vm._v(" " + _vm._s(_vm.T.contestListEmpty) + " ")
                      ])
                    : _vm._l(_vm.contestList, function(contestItem) {
                        return _c("omegaup-contest-card", {
                          key: contestItem.contest_id,
                          attrs: { contest: contestItem },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "contest-enroll-status",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "text-contest-date",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-card-text",
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "calendar-alt" }
                                        }),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getTimeLink(
                                                contestItem.start_time
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.ui.formatString(
                                                    _vm.T.contestStartedTime,
                                                    {
                                                      startedDate: _vm.startContestDate(
                                                        contestItem
                                                      )
                                                    }
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "contest-button-enter",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "contest-button-see-details",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                  _vm.loading && !_vm.contestListEmpty
                    ? _vm._l(3, function(index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "card contest-card mb-3" },
                          [_c("div", { staticClass: "line" })]
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }